/**
 * Created by jzj on 2018/10/5.
 */
'use strict'

const axios = require('axios')
const lang = require('./lang')

const baseUrl = require('./const').api
console.log('baseUrl', baseUrl)
axios.defaults.timeout = 5000
axios.interceptors.request.use(
  config => {
    config.baseURL = baseUrl
    // config.headers = {
    //   ...config.headers,
    // 'Content-Type': 'application/x-www-form-urlencoded',
    // }
    config.params = {
      ...config.params,
      lang: lang.getApiLang(),
      client: 'web',
    }
    console.log('[api] [request]')
    console.log(config)
    return config
  },
  error => {
    console.log('[api] [request] [error]')
    console.log(error)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    if (!response || !response.data || response.data.code !== 0) {
      return Promise.reject({
        msg: 'error',
        response: response
      })
    }
    console.log('[api] [response] [success]')
    console.log(response)
    return response.data.data
  },
  error => {
    console.log('[api] [response] [error]')
    console.log(error)
    return Promise.reject(error)
  }
)

export function getCategories () {
  return axios({url: '/category-list', method: 'get'})
}

export function getDApps (params) {
  const defaults = {
    category: null,
    sort: 'user1d',
    order: 'desc',
    offset: 0,
    limit: 20,
  }
  return axios({
    url: 'dapp-list',
    method: 'get',
    params: {
      ...defaults,
      ...params,
      page: null,
    }
  })
}

export function getDApp (id) {
  return axios({url: `/dapp/${id}`, method: 'get'})
}

export function getHomeData () {
  return axios({url: `/home`, method: 'get'})
}

export function submitDapp (dapp) {
  return axios({
    url: '/dapp',
    method: 'put',
    data: dapp,
    headers: {
      'Content-Type': 'application/json;charset=utf8',
    }
  })
}



// WEBPACK FOOTER //
// ./src/api.js